import React, { useState, useRef, useEffect } from 'react';
import Home from './components/Home.js';
import Header from './components/Header.js';
import LoadingModal from './components/LoadingModal.js';
import ErrorModal from './components/ErrorModal.js';
import ResultModal from './components/ResultModal.js';
import BookModal from './components/BookModal.js';
import BookSuccessModal from './components/BookSuccessModal.js';
import AboutModal from './components/AboutModal.js';
import FaqModal from './components/FaqModal.js';
import axios from 'axios';
import config from './config.js';

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = (e) => {
    setIsOpen(!isOpen);
  }

  // Declare Modals References
  const loadingModalRef = useRef(null);
  const errorModalRef = useRef(null);
  const resultModalRef = useRef(null);
  const bookModalRef = useRef(null);
  const bookSuccessModalRef = useRef(null);
  const aboutModalRef = useRef(null);
  const faqModalRef = useRef(null);

  // An array to contain all of the modal refs
  const modalRefArray = [
    loadingModalRef,
    errorModalRef,
    resultModalRef,
    bookModalRef,
    bookSuccessModalRef,
    aboutModalRef,
    faqModalRef
  ];

  // Modals Manipulation Functions
  const removeBackdrop = () => {
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach((backdrop) => backdrop.remove());
  }

  const hideModal = (modalRef) => {
    const modal = window.bootstrap.Modal.getInstance(modalRef.current);
    if (modal) modal.hide();
    removeBackdrop();
  }

  const showModal = (modalRef) => {
    removeBackdrop();
    const modal = new window.bootstrap.Modal(modalRef.current);
    modal.show();
  }

  const hideAllModal = (modalRefArray) => {
    modalRefArray.forEach((modalRef) => {
      hideModal(modalRef);
    });
  }

  // State Variable to Set Active Modal
  const [currentModal, setCurrentModal] = useState('');

  // Modal handling inside useEffect to avoid repeated triggers
  useEffect(() => {
    if (currentModal) {
      hideAllModal(modalRefArray);

      if (currentModal === "loadingModal") {
        showModal(loadingModalRef);
      } else if (currentModal === "errorModal") {
        showModal(errorModalRef);
      } else if (currentModal === "resultModal") {
        showModal(resultModalRef);
      } else if (currentModal === "bookModal") {
        showModal(bookModalRef);
      } else if (currentModal === "bookSuccessModal") {
        showModal(bookSuccessModalRef);
      } else if (currentModal === "aboutModal") {
        showModal(aboutModalRef);
      } else if (currentModal === "faqModal") {
        showModal(faqModalRef);
      }
    }
  }, [currentModal]); // Runs only when `currentModal` changes

  // Form Functions
  const [formData, setFormData] = useState({
    destination: '',
    budget: '',
    length: '',
    person: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }

  const [responseMessage, setResponseMessage] = useState('');

  const handleSubmit = async (e) => {
    // Prevent regular form submit behavior
    e.preventDefault();

    // Show loading modal
    setCurrentModal("loadingModal");

    console.log('FormData:', formData);

    // Try-Catch to wrap Axios HTTP request
    try {
      //  Axios HTTP request
      const response = await axios.post(`${config.baseUrl}/form-submit`, formData);

      // Success handler
      if (response.status === 201) {
        setResponseMessage(response.data.message);
        setCurrentModal("resultModal");
        console.log(response);
      }
    } catch (error) {
      setResponseMessage('There seems to be an error, we apologize for the inconvenience. Please try again later!');
      setCurrentModal("errorModal");
    }
  }

  // HTML
  return (
    <div className='wrap'>
      <div className="container mainContainer">
        <Header isOpen={isOpen} toggleMenu={toggleMenu} setCurrentModal={setCurrentModal} />
        <Home
          useState={useState}
          formData={formData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
        <LoadingModal loadingModalRef={loadingModalRef} />
        <ErrorModal errorModalRef={errorModalRef} />
        <ResultModal setCurrentModal={setCurrentModal} resultModalRef={resultModalRef} responseMessage={responseMessage} />
        <BookModal setCurrentModal={setCurrentModal} bookModalRef={bookModalRef} formData={formData} />
        <BookSuccessModal setCurrentModal={setCurrentModal} bookSuccessModalRef={bookSuccessModalRef} />
        <AboutModal setCurrentModal={setCurrentModal} aboutModalRef={aboutModalRef} />
        <FaqModal setCurrentModal={setCurrentModal} faqModalRef={faqModalRef} />
      </div>
    </div>
  );
}

export default App;